import styled from 'styled-components';

// Components
import * as S from '../../Badge/Styled';

export const Login = styled.div`
  width: 360px;
  max-width: 100%;
  background: var(--white);
  border-radius: 12px;

  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const Container = styled.div`
  padding: 28px 35px 28px;

  @media (max-width: 767px) {
    padding: 24px 20px;
  }
`;

export const Footer = styled.footer`
  padding: 21px 35px;
  background: var(--aluminium10);
  border-radius: 0 0 12px 12px;
  border-top: 1px solid var(--aluminium35);

  @media (max-width: 767px) {
    padding: 16px 20px;
  }
`;

export const ForgotPassLink = styled.div`
  color: var(--blue100);
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: var(--blue120);
    text-decoration: none;
  }
`;

export const SignupLink = styled.div`
  color: var(--blue100);
  cursor: pointer;
  padding-left: 5px;

  &:hover {
    color: var(--blue120);
  }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 1.4em;
  color: var(--carbone100);
  margin-bottom: 1.3em;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }

  .input {
    flex-grow: 1;
  }

  ${S.ExtBadge} {
    position: absolute;
    top: -5px;
    right: -25px;
  }
`;

export const Error = styled.div`
  position: absolute;
  bottom: -18px;
  left: 0;
  font-size: 12px;
  color: var(--red120);
`;

export const SpinnerCase = styled.div`
  height: 200px;
  display: flex;
  align-items: center;
`;

export const BText = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: var(--carbone80);

  ${S.ExtBadge} {
    position: absolute;
    top: -17px;
    right: -25px;
  }
`;
